import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../../../Components/PageTitle";
import { Link, useParams, useNavigate } from "react-router-dom";

import SearchInput from "../../../Components/Inputs/SearchInput";
import DateRangeButton from "../../../Components/Buttons/DateRangeButton";
import { BOOKINGS_TABS, URL } from "../Bookings";
import BookingsMultiFilter from "../Components/BookingsMultiFilter";
import { dateFilterChanged, multiFilterChanged, searchTermChanged } from "../Redux/FiltersReducer";
import ResourceSelector from "../../../Components/Inputs/Selects/ResourceSelector";
import BookingsLogsTitleAction from "../Components/BookingsLogsTitleAction";
import { fromSlug } from "../../../Helpers/StringHelper";

const LogsTitle = (props) => {
    const dispatch = useDispatch();
    const routeParams = useParams();
    const navigate = useNavigate();

    const permissions = useSelector(state => state.module.BOOKINGS.common.permissions);

    const {dateRangeStart, dateRangeEnd, searchTerm, multiFilter, category, amenity }
        = useSelector(state => state.module['BOOKINGS'].filters);

    const getPageTitle = () => {
        let typeTitle = '';

        if (amenity && amenity !== 'all') {
            const amenityWithoutCategory = amenity.replace(category, '');
            typeTitle = fromSlug(amenityWithoutCategory, true)+' ';
        } else if (category && category !== 'all') {
            typeTitle = fromSlug(category, true)+' ';
        }

        return (props.view === 'all-bookings')
            ? `All ${typeTitle}Bookings`
            : `My ${typeTitle}Bookings`;
    };

    const getBookingUrl = () => {
        if (category && amenity) {
            return `/bookings/book/${category}/list/${amenity}`;
        }

        if (category && category !== 'all') {
            return `/bookings/book/${category}`;
        }

        return `/bookings/book`;
    }

    const getTitleButtons = () => {
        // Don't render buttons until we get the permissions
        if (!permissions) {
            return null;
        }

        let buttons = []; {}

        // LPD-4227 Only ever show a link back to all-bookings for "admin" users
        // who somehow ended up on the my-bookings view
        if ((permissions.view_user_prop || permissions.view_all) && props.view === 'my-bookings') {
            buttons.push(
                <Link to={`${URL.BOOKINGS_ALL}/${props.scope}`} className="button secondary">
                    All Bookings
                </Link>
            );
        }

        buttons.push(
            <Link to={getBookingUrl()} className="button primary">
                Booking Categories
            </Link>
        );
        return buttons;
    }

    // Just ensure that the default url segmenent for category (all)
    // gets passed to the component as an empty string
    const parseSelectedCategorySlug = () => {
        if (routeParams?.categorySlug === 'all') {
            return '';
        }
        return routeParams?.categorySlug ?? '';
    }

    const getFilterComponents = () => {
        let components = [];

        components.push(
            <div className="button-group align-right small-on-mobile">
                <DateRangeButton
                    className="secondary"
                    startDate={dateRangeStart}
                    endDate={dateRangeEnd}
                    onChange={(start, end) => dispatch(dateFilterChanged(start, end))}
                    type={props.scope}
                    minDate={(props.scope === BOOKINGS_TABS.UPCOMING) ? new Date() : undefined}
                    maxDate={(props.scope === BOOKINGS_TABS.PAST) ? new Date() : undefined}
                />
            </div>
        );

        components.push(
            <ResourceSelector
                name={'categorySlug'}
                module={'bookings'}
                type={'categories'}
                value={parseSelectedCategorySlug()}
                placeholder="Category"
                staticOptions={[{value: '', label: 'All Categories'}]}
                onChange={(name, value) => {
                    const newPath = `/bookings/logs/${routeParams.view}/${routeParams.scope}/${value}`;
                    navigate(newPath);
                }}
            />
        )

        components.push(
            <BookingsMultiFilter
                value={multiFilter ?? []}
                onChange={(values) => { dispatch( multiFilterChanged(values) ) }}
            />
        );

        components.push(
            <SearchInput
                value={searchTerm}
                onChange={(text) => dispatch(searchTermChanged(text))}
            />
        )

        return components;
    }

    return (
        <PageTitle
            title={getPageTitle()}
            filterComponents={getFilterComponents()}
            titleAction={<BookingsLogsTitleAction/>}
            bottomRightComponents={[]}
            buttonComponents={getTitleButtons()}
            topRightColumnSize={(props.view === 'my-bookings') ? 5 : 3}
        />
    );
}

LogsTitle.defaultProps = {
    view: false,
    scope: false,
    buttonComponents: [],
}

export default LogsTitle;
